<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
 <div class="loadingDataPosition">
     <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col>
                    <label tag="div">Folder</label>
                    <b-form-input type="text"
                                 placeholder="Folder"
                                 v-model="form.folder"
                                 name="folder">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('folder')" v-if="form.errors.has('folder')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Folder Backup</label>
                    <b-form-input type="text"
                                 placeholder="Folder Backup"
                                 v-model="form.folder_backup"
                                 name="folder_backup">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('folder_backup')" v-if="form.errors.has('folder_backup')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Extensão Arq.</label>
                    <b-form-input type="text"
                                 placeholder="Extensão Arq."
                                 v-model="form.extensao_arq"
                                 name="extensao_arq">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('extensao_arq')" v-if="form.errors.has('extensao_arq')"></b-form-feedback>
                </b-col>

                <b-col>
                    <label tag="div">Conexão</label>
                    <multiselect v-model="conexaoSelected"
                    :options="optionsConexao"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('pesconftp_id')" v-if="form.errors.has('pesconftp_id')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </form>
    </div>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingPessoa: false,
      statusSelected: [],
      optionsLivStatus: [],
      conexaoSelected: [],
      optionsConexao: [],
      form: new Form({ folder: '',
                       folder_backup: '',
                       pesconftp_id: '',
                       pessoa_id: '',
                       extensao_arq: '',
                       pesint_id: '',
                       status: '',
                   }),
     helpForm: new Form({statusRecord: [], params: [], search: '', pessoa_id: ''}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    conexaoSelected(obj) {
        this.form.pesconftp_id = obj.value;
    }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
    },
    onCreate (data)
    {
      this.loadingData = true;
      this.getLivGeral(data.pessoa_id);
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar Interface FTP";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.statusSelected = [];
      this.conexaoSelected = [];
      this.form.pessoa_id = data.pessoa_id;
      this.form.pesint_id = data.pesint_id;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Interface FTP";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.statusSelected = [];
      this.conexaoSelected = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.host = data.host;
      this.form.porta = data.porta;
      this.form.usuario = data.usuario;
      this.form.senha = data.senha;
      this.statusSelected = { label: data.status.descr, value: data.status.valor };
      this.form.pesint_id = data.pesint_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/pessoainterfaceftp/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/pessoainterfaceftp/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    getLivGeral(data) {
        this.helpForm.pessoa_id = data;
        this.optionsLivStatus = [];
        this.optionsConexao = [];
        this.helpForm.post('/api/pessoainterfaceftp/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.conexao.forEach((obj)=>
            {
                this.optionsConexao.push({ label: obj.descr, value: obj.pesconftp_id })
            })
            this.loadingData = false;
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, false, false)
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
